import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, Inject, Injectable, Input, NgModule, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Metadata } from '../models/share-point';
import { PipesModule } from '../pipes/pipes_api';
import { SharePointService, SpGetOptions } from '../services/share-point';

export interface Alert {
  Title: string;
  Details: string;
  Priority: 'danger' | 'warning' | 'info';
  Dismissible: boolean;
  Id: number;
  ShowDate: Date;
  HideDate: Date;
  __metadata: Metadata;
}

@Component({
  selector: 'to-alerts',
  templateUrl: './alerts.html',
  styleUrls: ['./alerts.scss']
})
export class AlertsComponent implements OnInit {
  @Input() helpCenter: string;
  private dismissed: number[] = [];
  alerts: Alert[];

  constructor(
    private alertsService: AlertsService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    timer(2000, 180000).pipe(
      switchMap(() => this.alertsService.get(this.helpCenter)),
      map((alerts: Alert[]) => alerts.filter(alert => this.dismissed.indexOf(alert.Id) === -1))
    ).subscribe(alerts => this.alerts = alerts);
  }

  view(data: Alert) {
    this.dialog.open(AlertDialogComponent, { data });
  }

  close(alert: Alert) {
    this.dismissed.push(alert.Id);
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

}

@Component({
  selector: 'to-alert-dialog',
  template: `
    <h4 mat-dialog-title>{{ alert.Title }}</h4>
    <div mat-dialog-content>
      <div [innerHTML]="alert.Details | safeHtml"></div>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button color="primary" matDialogClose cdkFocusInitial>Close</button>
    </div>
  `,
})
export class AlertDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public alert: Alert,
  ) { }
}

@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  private _alertsList = 'Alerts';
  private _day = new Date().toISOString();

  private _spGetOptions: SpGetOptions = {
    hideOnErrors: true,
    headers: {
      Accept: 'application/json;odata=nometadata',
    },
    params: {
      $select: 'Title, Details, Priority, Dismissible, ShowDate, HideDate, Id',
      $filter: `ShowDate le datetime'${this._day}' and HideDate ge datetime'${this._day}'`
    }
  };

  constructor(
    private spService: SharePointService,
  ) { }

  get(helpCenter?: string): Observable<Alert[]> {
    if (helpCenter) {
      this._spGetOptions.params.$filter += ` and HelpCenter/Title eq '${helpCenter}'`;
    }
    return this.spService.get<Alert>(this._alertsList, this._spGetOptions);
  }

}

@NgModule({
  declarations: [
    AlertsComponent,
    AlertDialogComponent,
  ],
  exports: [
    AlertsComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    PipesModule,
    RouterModule,
    MatDialogModule,
    MatButtonModule,
  ],
  entryComponents: [
    AlertDialogComponent
  ],
})
export class AlertsModule { }
